import styled from 'styled-components';
import { IconSize, HelpIcon } from '@ardoq/icons';
import { colors, s8 } from '@ardoq/design-tokens';
import { DoqLayout, DoqType, DoqWithSpeechBubble } from '@ardoq/doq';
import { FlexBox } from '@ardoq/layout';
import type { EmptyResultsDoqyLabels } from './labels';

export type { EmptyResultsDoqyLabels };

export const StyledHelpIcon = styled(HelpIcon).attrs({
  iconSize: IconSize.LARGE,
})`
  margin-left: ${s8};
  vertical-align: middle;
  color: ${colors.grey500};

  &:hover {
    cursor: pointer;
  }
`;

const DEFAULT_EMPTY_RESULTS_LABELS = {
  title: 'No data to show',
  message: 'No results were found from your workspaces using your query',
} satisfies Required<EmptyResultsDoqyLabels>;

export const EmptyResultsDoqy = ({
  labels,
}: { labels?: EmptyResultsDoqyLabels } = {}) => {
  const { title, message } = { ...DEFAULT_EMPTY_RESULTS_LABELS, ...labels };
  return (
    <FlexBox justify={'center'} align={'center'} height={'full'}>
      <DoqWithSpeechBubble
        doqType={DoqType.MISSING_ORG}
        layout={DoqLayout.DIALOG}
        title={title}
        message={message}
      />
    </FlexBox>
  );
};
